
import Vue from 'vue'
import { SET_IS_LOADING_APP } from '@/store/mutation-types'
import { WOOP_WEBSITE } from '@/constants'

export default Vue.extend({
  name: 'not-found',
  data() {
    return {
      WOOP_WEBSITE,
    }
  },
  mounted() {
    // remove loading app page
    this.$store.commit(SET_IS_LOADING_APP, false)
  },
})
